// extracted by mini-css-extract-plugin
export default {"main":"not-found_main__KPj1t","link":"not-found_link__vvJaa","link__wrapper":"not-found_link__wrapper__lpveu"};